import { Anchor, Clock, Wallet } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { IMAGES } from "@/lib/api";

export default function Hero() {
  const { t } = useLang();
  return (
    <section className="relative min-h-[100svh] flex items-end overflow-hidden" data-testid="hero-section">
      <img src={IMAGES.hero} alt="Blue Army, speedboat 28 pieds de Jolly Roger LTD" data-testid="hero-image" className="absolute inset-0 w-full h-full object-cover object-[42%_55%] lg:object-[65%_45%]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050B14]/90 via-[#050B14]/45 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#050B14] to-transparent" />
      <div className="relative max-w-7xl mx-auto w-full px-5 sm:px-10 pb-20 pt-32">
        <p className="rise rise-1 text-[#D4AF37] tracking-[0.35em] text-xs sm:text-sm uppercase mb-6">{t.hero_kicker}</p>
        <h1 className="rise rise-2 font-display text-5xl sm:text-6xl lg:text-8xl leading-[0.95] max-w-4xl [text-shadow:0_4px_30px_rgba(0,0,0,.5)]" data-testid="hero-title">
          {t.hero_title}
        </h1>
        <p className="rise rise-3 mt-8 text-base sm:text-lg text-slate-200 max-w-xl">{t.hero_sub}</p>
        <div className="rise rise-4 mt-10 flex flex-wrap gap-4">
          <a href="#reserver" data-testid="hero-book-btn" className="bg-[#D4AF37] text-[#050B14] px-8 py-4 font-medium tracking-wider hover:bg-[#e6c55a] hover:-translate-y-0.5 transition-[background-color,transform] duration-300">
            {t.hero_cta}
          </a>
          <a href="#excursions" data-testid="hero-excursions-btn" className="border border-white/30 px-8 py-4 tracking-wider hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300">
            {t.hero_cta2}
          </a>
        </div>
        <div className="rise rise-4 mt-14 flex flex-wrap gap-x-10 gap-y-3 text-sm text-slate-300">
          <span className="flex items-center gap-2"><Anchor className="w-4 h-4 text-[#D4AF37]" />{t.loc_from}</span>
          <span className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#D4AF37]" />{t.hero_promise.split("·")[0]}</span>
          <span className="flex items-center gap-2"><Wallet className="w-4 h-4 text-[#D4AF37]" />{t.hero_promise.split("·")[1]}</span>
        </div>
      </div>
    </section>
  );
}
